/**
 * Utilidades para manejo de números y conversiones de formato
 */

/**
 * Convierte un string con formato argentino (coma) a número con punto decimal
 * @param {string|number} value - Valor a convertir (ej: "85,5")
 * @returns {number|null} Número con punto decimal (ej: 85.5) o null si es inválido
 * @example
 * parseArgentinoToNumber("85,5") // 85.5
 * parseArgentinoToNumber("100") // 100
 * parseArgentinoToNumber("") // null
 */
export const parseArgentinoToNumber = (value) => {
    if (!value || value === "") return null;
    // Reemplazar coma por punto
    const normalized = value.toString().replace(',', '.');
    const number = Number.parseFloat(normalized);
    return Number.isNaN(number) ? null : number;
};

/**
 * Convierte un número a string con formato argentino (coma)
 * @param {number|string} value - Valor a convertir (ej: 85.5)
 * @returns {string} String con formato argentino (ej: "85,5")
 * @example
 * formatNumberToArgentino(85.5) // "85,5"
 * formatNumberToArgentino(100) // "100"
 * formatNumberToArgentino(null) // ""
 */
export const formatNumberToArgentino = (value) => {
    if (value === null || value === undefined || value === "") return "";
    return Number(value).toString().replace('.', ',');
};
